import MiniMasonry from "minimasonry";

let element = document.querySelector(".masonry");

if (element != null) {
  var masonry = new MiniMasonry({
    container: ".masonry",
    surroundingGutter: false,
    gutter: 42,
    ultimateGutter: 21,
    minify: true,
  });
  element
    .querySelectorAll("img")
    .forEach((img) => img.addEventListener("load", () => masonry.layout()));
}
